<template>
  <div class="p-4 mb-6 bg-white rounded-md shadow-md">
    <h3 class="mb-3 text-lg font-semibold text-gray-800">
      Statistik Pengunjung
    </h3>

    <div class="space-y-4" v-if="!loading">
      <div
        class="flex items-center p-3 transition-all border rounded-md bg-gray-50 hover:bg-gray-100"
      >
        <div class="p-2 mr-3 text-white bg-blue-500 rounded-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <div>
          <p class="text-sm text-gray-500">Hari Ini</p>
          <p class="text-xl font-bold">{{ stats.todayVisits }}</p>
        </div>
      </div>

      <div
        class="flex items-center p-3 transition-all border rounded-md bg-gray-50 hover:bg-gray-100"
      >
        <div class="p-2 mr-3 text-white bg-green-500 rounded-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            />
          </svg>
        </div>
        <div>
          <p class="text-sm text-gray-500">Bulan Ini</p>
          <p class="text-xl font-bold">{{ stats.monthlyVisits }}</p>
        </div>
      </div>

      <div
        class="flex items-center p-3 transition-all border rounded-md bg-gray-50 hover:bg-gray-100"
      >
        <div class="p-2 mr-3 text-white bg-purple-500 rounded-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
            />
          </svg>
        </div>
        <div>
          <p class="text-sm text-gray-500">Total Pengunjung</p>
          <p class="text-xl font-bold">{{ stats.totalVisits }}</p>
        </div>
      </div>
    </div>

    <!-- Loading state -->
    <div v-else class="space-y-3">
      <div
        v-for="i in 3"
        :key="i"
        class="flex items-center p-3 bg-gray-100 rounded-md animate-pulse"
      >
        <div class="w-10 h-10 mr-3 bg-gray-300 rounded-md"></div>
        <div class="flex-1">
          <div class="w-24 h-3 mb-2 bg-gray-300 rounded"></div>
          <div class="w-16 h-5 bg-gray-300 rounded"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import axios from "axios";

const props = defineProps({
  visitorData: {
    type: Object,
    default: () => ({
      total: 0,
      today: 0,
      lastWeek: 0,
      lastMonth: 0,
      lastYear: 0,
    }),
  },
});

const loading = ref(false);

// Menggunakan data dari props jika tersedia, atau fetch dari API
const stats = computed(() => {
  if (props.visitorData && props.visitorData.total !== undefined) {
    return {
      totalVisits: props.visitorData.total,
      todayVisits: props.visitorData.today,
      monthlyVisits: props.visitorData.lastMonth,
      yearlyVisits: props.visitorData.lastYear,
    };
  }
  return statsData.value;
});

const statsData = ref({
  totalVisits: 0,
  todayVisits: 0,
  monthlyVisits: 0,
  yearlyVisits: 0,
});

onMounted(async () => {
  // Jika tidak ada data dari props, fetch dari API
  if (!props.visitorData || props.visitorData.total === undefined) {
    loading.value = true;
    try {
      const response = await axios.get("/api/visitor-stats");
      statsData.value = response.data;
      loading.value = false;
    } catch (error) {
      console.error("Error fetching visitor statistics:", error);
      loading.value = false;
    }
  }
});
</script>
